import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DefaultLayout from "./component/Layout/DefaultLayout";
import Home from "./component/Page/Home";
import Login from "./component/Page/Login";
import Logout from "./component/Logout";
import Registration from "./component/Page/Registration";
import VerifySuccess from "./component/Page/VerifySuccess";
import RejectSuccess from "./component/Page/RejectSuccess";
import Dashboard from "./page/Dashboard";
import EditProfile from "./component/EditProfile";
import ForgetPassword from "./component/Page/ForgetPassword";
import ResetPassword from "./component/Page/ResetPassword";
// import EditProfile from "./component/Page/EditProfile";
// import Profile from "./component/Page/Profile";
// import ChangePassword from "./component/Page/ChangePassword";
// import History from "./component/Page/History";
// import PaymentDetail from "./page/PaymentDetail";
// import Thankyou from "./page/Thankyou";
// import Compare from "./page/CompareUnit";
// import MoreDetail from "./page/MoreDetail";
// import AdminConfig from "./page/AdminConfig";
// import PrivacyPolicy from "./component/Page/PrivacyPolicy";
// import { ViewAction, FavAction, UnitAction, loadWishlistAction, NameAction } from "./actions";
// import Term_Condition from "./page/Term_Condition";
// import PDFFile from "./component/PDFFile";

import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Users from "./page/UserList";
import UserEdit from "./page/UserEdit";
import UserView from "./page/UserView";
import CourseList from "./component/CourseList";
import CoursePassedList from "./component/CoursePassedList";
import CourseForm from "./component/CourseForm";
import StudentExam from "./component/StudentExam";
import ExamReview from "./component/ExamReview";
import CourseDetail from "./component/CourseDetail";
import CertificatesPage from "./component/CertificatesPage";
import IssueCertificatePage from "./component/IssueCertificatePage";
import TeacherCourseReport from "./component/TeacherCourseReport";

import "./style/styles.scss";

import { LocalStorageProvider } from "./contexts/LocalStorageContext";

const App = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [socket, setSocket] = useState(null);
    const [socketID, setSocketID] = useState();
    const [user, setUser] = useState(null);
    const [getUser, setGetUser] = useState();
    const [room, setRooms] = useState([]);
    const [viewRoom, setViewRoom] = useState([]);
    const [roomNumber, setRoomNumber] = useState();
    const [view, setView] = useState([]);
    const [wishlist, setWishlist] = useState([]);
    const [wishlistDB, setWishlistDB] = useState([]);
    const [adminWishlist, setAdminWishlist] = useState();
    const [adminStatus, setAdminStatus] = useState();
    const [count_wishlists, setCount_wishlists] = useState();
    const [locked, setLocked] = useState();
    const [timer, setTimer] = useState();
    const [sold, setSold] = useState();
    const [data, setData] = useState();
    const [fakeUser, setFakeUser] = useState();
    const [openDetail, setOpenDetail] = useState(false);
    const [timeLock, setTimeLock] = useState(false);
    const [timeSeconds, setTimerSeconds] = useState("10");
    const [timerMinutes, setTimerMinutes] = useState("00");
    const [dashboard, setDashboard] = useState([]);
    const [floorArray, setFloorArray] = useState([]);
    const [totalFloors, setTotalFloors] = useState([]);
    const [availableRoom, setAvailableRoom] = useState([]);
    const [totalUser, setTotalUser] = useState(0);
    const wishlistLocal = useSelector((state) => state.wishlist);
    const admin = JSON.parse(localStorage.getItem("auth"));
    const cookies = new Cookies();
    const auth = cookies.get("authToken");
    const config = { headers: { "auth-token": auth } };
    if (auth && !localStorage.getItem("auth")) {
        window.location = "/logout";
    }

    const [isReload, setIsReload] = useState(false);

    let nowDate = new Date();
    let now = nowDate.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
    let nowTimeStamp = new Date(now).getTime();
    let openTime = new Date(2023, 8, 13, 15, 0, 0);
    let openTimeStamp = openTime.getTime();

    return (
        <BrowserRouter>
            <LocalStorageProvider>
                <Routes>
                    <Route path="/" element={<DefaultLayout cookies={cookies} sidebar={false} />}>
                        <Route index element={auth ? <Navigate to="/dashboard" replace /> : <Home />} />
                    </Route>

                    <Route path="/logout" element={<Logout />} />

                    <Route path="/login" element={<DefaultLayout cookies={cookies} sidebar={false} />}>
                        <Route index element={auth ? <Navigate to={`/`} /> : <Login />} />
                    </Route>

                    <Route path="/registration" element={<DefaultLayout cookies={cookies} sidebar={false} />}>
                        <Route index element={auth ? <Navigate to={`/`} /> : <Registration />} />
                    </Route>

                    <Route
                        path="/verify-account/:verifyCode"
                        element={<DefaultLayout cookies={cookies} sidebar={false} />}
                    >
                        <Route index element={<VerifySuccess />} />
                    </Route>
                    <Route
                        path="/reject-account/:verifyCode"
                        element={<DefaultLayout cookies={cookies} sidebar={false} />}
                    >
                        <Route index element={<RejectSuccess />} />
                    </Route>

                    {/* Auth */}
                    <Route path="/users/edit" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <EditProfile /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/dashboard" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <Dashboard /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/users/:role" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <Users /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/users/:role/edit/:userID" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <UserEdit /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/users/:role/view/:userID" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <UserView /> : <Navigate to={`/`} />} />
                    </Route>

                    {/* Course */}
                    <Route path="/course" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CourseList /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/course_passed" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CoursePassedList /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/course/:id" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CourseDetail /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/course/new" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CourseForm /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/course/edit/:id" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CourseForm /> : <Navigate to={`/`} />} />
                    </Route>

                    <Route path="/course/:courseId/exam" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <StudentExam /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/course/:courseId/exam-review" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <ExamReview /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/certificates" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <CertificatesPage /> : <Navigate to={`/`} />} />
                    </Route>
                    <Route path="/issue-certificate" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <IssueCertificatePage /> : <Navigate to={`/`} />} />
                    </Route>

                    <Route path="/report" element={<DefaultLayout cookies={cookies} />}>
                        <Route index element={auth ? <TeacherCourseReport /> : <Navigate to={`/`} />} />
                    </Route>

                    <Route path="/forget-password" element={<DefaultLayout cookies={cookies} sidebar={false} />}>
                        <Route index element={auth ? <Navigate to={`/`} /> : <ForgetPassword />} />
                    </Route>
                    <Route
                        path="/reset/:resetPasswordCode"
                        element={<DefaultLayout cookies={cookies} sidebar={false} />}
                    >
                        <Route index element={<ResetPassword />} />
                    </Route>

                    {/* <Route
                    path="/privacy-policy"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={<PrivacyPolicy />} />
                </Route>

                

                

                <Route path="/verify-account/:verifyCode" element={<DefaultLayout cookies={cookies} />}>
                    <Route index element={<VerifySuccess />} />
                </Route>

                <Route
                    path="/edit-profile"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={auth ? <EditProfile /> : <Navigate to={`/`} />} />
                </Route>

                <Route
                    path="/profile"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={auth ? <Profile /> : <Navigate to={`/`} />} />
                </Route>

                <Route
                    path="/change-password"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={auth ? <ChangePassword /> : <Navigate to={`/`} />} />
                </Route>

                <Route
                    path="/history"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={auth ? <History /> : <Navigate to={`/`} />} />
                </Route>

                <Route
                    path="/dashboard"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={
                            auth ? (
                                <Dashboard
                                    emitWishlists={emitWishlists}
                                    timer={timer}
                                    data={data}
                                    openDetail={openDetail}
                                    setOpenDetail={setOpenDetail}
                                    setLock={setLock}
                                    locked={locked}
                                    toggleDetail={toggleDetail}
                                    wishlistLocal={wishlistLocal}
                                    totalFloors={totalFloors}
                                    dashboard={dashboard}
                                    availableRoom={availableRoom}
                                    user={user}
                                    room={room}
                                    closeDetail={closeDetail}
                                    randomFakeUser={fakeUser}
                                    totalUser={totalUser}
                                />
                            ) : (
                                <Navigate to={`/`} />
                            )
                        }
                    />
                </Route>

                <Route
                    path="/payment/:roomNumber/:username"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={
                            auth ? (
                                <PaymentDetail
                                    timer={timer}
                                    data={data}
                                    locked={locked}
                                    timeLock={timeLock}
                                    timerMinutes={timerMinutes}
                                    timeSeconds={timeSeconds}
                                    availableRoom={availableRoom}
                                    user={user}
                                    setOpenDetail={setOpenDetail}
                                    randomFakeUser={fakeUser}
                                    totalUser={totalUser}
                                />
                            ) : (
                                <Navigate to={`/`} />
                            )
                        }
                    />
                </Route>

                <Route
                    path="/thankyou"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={auth ? <Thankyou setsold={setsold} UnlockRoom={UnlockRoom} /> : <Navigate to={`/`} />}
                    />
                </Route>

                <Route
                    path="/compare"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={
                            auth ? (
                                <Compare
                                    viewRoom={viewRoom}
                                    all_wishlist={wishlistDB}
                                    setData={setData}
                                    setLock={setLock}
                                    timer={timer}
                                    availableRoom={availableRoom}
                                    setView={setView}
                                    setCount_wishlists={setCount_wishlists}
                                    randomFakeUser={fakeUser}
                                    totalUser={totalUser}
                                />
                            ) : (
                                <Navigate to={`/`} />
                            )
                        }
                    />
                </Route>

                <Route
                    path="/more-detail/:roomNumber"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={
                            auth ? (
                                <MoreDetail
                                    timeLock={timeLock}
                                    timer={timer}
                                    setLock={setLock}
                                    totalFloors={totalFloors}
                                    availableRoom={availableRoom}
                                    setRoomNumber={setRoomNumber}
                                    room={room}
                                    randomFakeUser={fakeUser}
                                    totalUser={totalUser}
                                />
                            ) : (
                                <Navigate to={`/`} />
                            )
                        }
                    />
                </Route>

                <Route
                    path="/term_and_condition"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route index element={auth ? <Term_Condition /> : <Navigate to={`/`} />} />
                </Route>

                <Route path="/download/invoice">
                    <Route path=":refno" element={<PDFFile />} />
                </Route>

                <Route
                    path="/admin-config"
                    element={
                        <DefaultLayout
                            cookies={cookies}
                            showFooter={false}
                            emitWishlists={emitWishlists}
                            timer={timer}
                            setLock={setLock}
                            availableRoom={availableRoom}
                        />
                    }
                >
                    <Route
                        index
                        element={
                            auth && admin && admin.role == "admin" ? (
                                <AdminConfig
                                    availableRoom={availableRoom}
                                    adminWishlist={adminWishlist}
                                    getUser={getUser}
                                    adminStatus={adminStatus}
                                />
                            ) : (
                                <Navigate to={`/`} />
                            )
                        }
                    />
                </Route> */}
                </Routes>
            </LocalStorageProvider>
        </BrowserRouter>
    );
};

export default App;
